<template>
  <div class="itemBox" @mouseenter="showQRCode" @mouseleave="hideQRCode">
    <div class="itemShow" v-show="!showFlag">
      <img :src="itemInfoList[hoverIndex-1].img" alt />
    </div>
    <div class="hoverShow" v-show="showFlag">
      <img :src="itemInfoList[hoverIndex-1].imgShade" alt />
      <div class="text">{{itemInfoList[hoverIndex-1].text}}</div>
    </div>
  </div>
</template>
<script>
import img1 from "@/assets/img/home/gzz1.png";
import img2 from "@/assets/img/home/gzz2.png";
import img3 from "@/assets/img/home/gzz3.png";
import img4 from "@/assets/img/home/gzz4.png";
import img5 from "@/assets/img/home/gzz5.png";
import imgShade1 from "@/assets/img/home/gzzShade1.png";
import imgShade2 from "@/assets/img/home/gzzShade2.png";
import imgShade3 from "@/assets/img/home/gzzShade3.png";
import imgShade4 from "@/assets/img/home/gzzShade4.png";
import imgShade5 from "@/assets/img/home/gzzShade5.png";
export default {
  name: "hover",
  props: ["hoverIndex"],
  data() {
    return {
      showFlag: false,
      itemInfoList: [
        { img: img1, text: "文化投资" ,imgShade:imgShade1},
        { img: img2, text: "艺术展览" ,imgShade:imgShade2},
        { img: img3, text: "创意研发" ,imgShade:imgShade3},
        { img: img4, text: "市场开发" ,imgShade:imgShade4},
        { img: img5, text: "营销推广" ,imgShade:imgShade5}
      ]
    };
  },
  mounted() {
    console.log(this.hoverIndex);
  },
  methods: {
    showQRCode() {
      this.showFlag = true;
    },
    hideQRCode() {
      this.showFlag = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.itemBox {
  width: 264px;
  height: 230px;
  .itemShow {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .hoverShow {
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .text {
      width: 100%;
      text-align: center;
      line-height: 230px;
      position: absolute;
      top: 0;
      left: 0;
      font-size: 20px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/components/hoverItem3.vue